// extracted by mini-css-extract-plugin
module.exports = {"continueButton":"AddSimpleOutputs_continueButton__RcWOe","content":"AddSimpleOutputs_content__wdlpM"};